import axios from "axios";
import { tripCode, listLocalTrips } from "@/lib/access";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Attach the trip code this device holds so the server can authorise trip requests
api.interceptors.request.use((config) => {
  const m = /\/events\/([a-z0-9]+)(\/|$)/i.exec(config.url || "");
  if (m && m[1] !== "code") {
    const code = tripCode(m[1]);
    if (code) config.headers["X-Trip-Code"] = code;
  }
  if (/\/course-library\/[a-z0-9]+\/(trips|push)/i.test(config.url || "")) {
    const codes = Object.values(listLocalTrips()).map((t) => t.code).filter(Boolean);
    if (codes.length) config.headers["X-Trip-Codes"] = codes.join(",");
  }
  return config;
});

export async function listEvents() {
  const r = await api.get("/events");
  return r.data;
}
export async function createEvent(name) {
  const r = await api.post("/events", { name });
  return r.data;
}
export async function getEvent(id) {
  const r = await api.get(`/events/${id}`);
  return r.data;
}
export async function getEventByCode(code) {
  const r = await api.get(`/events/code/${code}`);
  return r.data;
}
export async function updateEvent(id, payload) {
  const r = await api.put(`/events/${id}`, payload);
  return r.data;
}
export async function deleteEvent(id) {
  const r = await api.delete(`/events/${id}`);
  return r.data;
}

// Course Library
export async function listCourseLibrary() {
  const r = await api.get('/course-library');
  return r.data;
}
export async function createLibraryCourse(payload) {
  const r = await api.post('/course-library', payload);
  return r.data;
}
export async function updateLibraryCourse(id, payload) {
  const r = await api.put(`/course-library/${id}`, payload);
  return r.data;
}
export async function deleteLibraryCourse(id) {
  const r = await api.delete(`/course-library/${id}`);
  return r.data;
}
export async function checkLibraryCourseUpdates(id, sourceId) {
  const r = await api.post(`/course-library/${id}/check-updates`, { sourceId: sourceId || null });
  return r.data;
}
export async function fetchLibraryCourseTrips(id) {
  const r = await api.get(`/course-library/${id}/trips`);
  return r.data;
}
export async function pushLibraryCourse(id) {
  const r = await api.post(`/course-library/${id}/push`);
  return r.data;
}
export const WS_BASE = `${BACKEND_URL.replace(/^http/, "ws")}/api`;
export async function patchScores(id, ops) {
  const r = await api.patch(`/events/${id}/scores`, { ops });
  return r.data;
}
export async function searchProfiles(q) {
  const r = await api.get(`/profiles`, { params: q ? { q } : {} });
  return r.data;
}
export async function createProfile(payload) {
  const r = await api.post(`/profiles`, payload);
  return r.data;
}
export async function getMyProfile() {
  const r = await api.get(`/profiles/me`);
  return r.data;
}
export async function saveMyProfile(payload) {
  const r = await api.put(`/profiles/me`, payload);
  return r.data;
}
export async function claimProfile(id) {
  const r = await api.post(`/profiles/${id}/claim`);
  return r.data;
}

// Auth
export async function exchangeSession(session_id) {
  const r = await api.post('/auth/session', { session_id });
  return r.data;
}
export async function fetchMe() {
  const r = await api.get('/auth/me');
  return r.data;
}
export async function logout() {
  const r = await api.post('/auth/logout');
  return r.data;
}

// Course search (GolfCourseAPI proxy)
export async function searchCoursesOnline(q) {
  const r = await api.get('/courses/search', { params: { q } });
  return r.data;
}
export async function fetchCourseDetails(course_id) {
  const r = await api.get(`/courses/details/${course_id}`);
  return r.data;
}

export async function claimEvent(id) {
  const r = await api.post(`/events/${id}/claim`);
  return r.data;
}
